import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTracking = () => {

    const location = useLocation();

    useEffect(() => {
        if (window.gtag) {

            let pathToSend = location.pathname === '/' || location.pathname === '/1' ? 'Health' : location.pathname.replace(/^\//, '');

            if (location.pathname === '/2') {
                pathToSend = 'Mobile';
            }
            else if (location.pathname === '/privacy-policy') {
                pathToSend = 'Privacy Policy';
            }
            else {
                pathToSend = 'Health';
            }

            console.log('Tracking page view:', pathToSend);

            window.gtag('config', 'G-HTEZ177JQ6', {
                page_path: pathToSend, // 👈 send 'Health' instead of '/'
            });
        }
    }, [location]);
};

export default usePageTracking;